import { alpha } from '@mui/material/styles';

const SEVERITY_TO_PALETTE = {
  pathogenic: 'error',
  uncertain: 'warning',
  benign: 'success',
  unclassified: 'default'
};

export const severityFromInterpretation = (interpretation) => {
  if (!interpretation) return 'unclassified';
  const s = String(interpretation).trim().toLowerCase();
  if (!s) return 'unclassified';
  // ClinVar publishes compound classifications like
  // "Pathogenic/Likely pathogenic", "Benign/Likely benign" and
  // "Conflicting classifications of pathogenicity". Substring matching
  // handles these and the canonical single-tier strings in one pass.
  // Order matters: conflicting first (since it contains "pathogenic"),
  // then pathogenic > uncertain > benign.
  if (s.includes('conflicting')) return 'uncertain';
  if (s.includes('pathogenic')) return 'pathogenic';
  if (s.includes('uncertain') || s === 'vus') return 'uncertain';
  if (s.includes('benign')) return 'benign';
  return 'unclassified';
};

export const paleChipSx = (severity) => (theme) => {
  const palette = SEVERITY_TO_PALETTE[severity] || 'default';

  if (palette === 'default') {
    return {
      bgcolor: theme.palette.grey[100],
      color: theme.palette.text.secondary,
      border: `1px solid ${theme.palette.grey[300]}`,
      fontWeight: 600,
      letterSpacing: '0.02em'
    };
  }

  const main = theme.palette[palette].main;
  return {
    bgcolor: alpha(main, 0.12),
    color: theme.palette[palette].dark,
    border: `1px solid ${alpha(main, 0.3)}`,
    fontWeight: 600,
    letterSpacing: '0.02em'
  };
};
